import FormPage from './FormPage';
export { FormPage };
export default FormPage;
